import React from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const EmployeeModal = ({ open, onClose, employee }) => {
  return (
    <Modal
      open={open}
      aria-labelledby="employee-modal-title"
      aria-describedby="employee-modal-description"
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          position: "relative",
          width: 900,
          height: "auto",
          backgroundColor: "white",
          padding: 3,
          borderRadius: "10px",
          boxShadow: 24,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose} // Close modal on button click
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Modal Content */}
        <h3 style={{ textAlign: "center", margin: "20px 0px" }}>
          {/* {employee?.type === "executive_team" ? "Executive Team" : "Team Member"} */}
          {employee?.name}
        </h3>
        <div className="d-flex justify-content-around mt-2">
          <div>
            <div className="d-flex gap-2">
              <h6 className="text-success" id="employee-modal-title">
                Employee ID:&nbsp;
              </h6>
              <span>{employee?.employee_id}</span>
            </div>
            <div className="d-flex gap-2">
              <h6 className="text-success" id="employee-modal-title">
                Employee Role:&nbsp;
              </h6>
              <span>{employee?.role}</span>
            </div>
            <div className="d-flex gap-2">
              <h6 className="text-success" id="employee-modal-title">
                Linkedin URL:&nbsp;
              </h6>
              <span>{employee?.social_link}</span>
            </div>
          </div>
          <img
            src={employee?.img_src}
            alt="Employee Img"
            height={150}
            width={150}
            style={{ borderRadius: "20px", objectFit: "contain" }}
          />
        </div>
      </Box>
    </Modal>
  );
};

export default EmployeeModal;
